import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useIntl } from '@leagueplatform/locales';
import { HeaderNavLink } from '@leagueplatform/solutions-foundation';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: HeaderNavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: 'STR_HOME' }),
      icon: 'descriptiveHome',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.benefits),
      label: formatMessage({ id: 'STR_BENEFITS' }),
      icon: 'capabilityWallet',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.claims),
      label: formatMessage({ id: 'STR_CLAIMS' }),
      icon: 'capabilityClaims',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
      label: formatMessage({ id: 'STR_GET_CARE' }),
      icon: 'descriptivePill',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: 'STR_JOURNEY' }),
      icon: 'capabilityJourney',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.aboutMe),
      label: formatMessage({ id: 'STR_ABOUT_ME' }),
      icon: 'descriptiveHeart',
    },
  ];
  return {
    navLinks: navLinksList,
  };
};
